export default __webpack_public_path__ + "static/empty-bag-thumb-1-49d60791758cc1290121f5f952ee01d4.webp";